import moment from 'moment'
import { DatePicker } from 'office-ui-fabric-react/lib/DatePicker'
import { IStackStyles, Stack } from 'office-ui-fabric-react/lib/Stack'
import { loadTheme } from 'office-ui-fabric-react/lib/Styling'
import { Text } from 'office-ui-fabric-react/lib/Text'
import * as React from 'react'
import { AsyncState } from 'widgets-for-react'
// import { datalayerHandler } from '../cms/blocks/utils/gtm.mod'
// import { parseParagraphs } from '../public_site/utils/helpers'
// import { slugify } from '../public_site/utils/utils'
import { postFormSubmissionState } from './api'
import { status_error_renderer, status_sending_renderer, status_thank_you_renderer } from './status_message_renderers'
import { DependenciesState, DependencyData, FieldData, FormData, FormState, StepData } from './types'
import {
  areDependenciesMet,
  are_all_dependencies_met,
  DayPickerStrings,
  is_dependency_met,
  parseParagraphs,
  slugify,
  sortBy,
  update_elem_in_list,
  update_field_AUX,
  update_field_file,
  StringEmptyOrNull
} from './utils'
import * as i18next from 'i18next'
import { decodeHTMLEntities, gtmPush } from '../../helpers'

// import _i18next = require('i18next')
// let i18next = _i18next.default

loadTheme({
  palette: {
    themePrimary: '#fff',
    themeLighterAlt: '#f3f4fa',
    themeLighter: '#d0d6e9',
    themeLight: '#aab5d6',
    themeTertiary: '#6678ae',
    themeSecondary: '#354a88',
    themeDarkAlt: '#21346c',
    themeDark: '#1c2c5b',
    themeDarker: '#152043',
    neutralLighterAlt: '#e5e6ec',
    neutralLighter: '#e1e3e8',
    neutralLight: '#d8d9de',
    neutralQuaternaryAlt: '#c9cacf',
    neutralQuaternary: '#c0c1c6',
    neutralTertiaryAlt: '#b8babe',
    neutralTertiary: '#aab5d6',
    neutralSecondary: '#6678ae',
    neutralPrimaryAlt: '#354a88',
    neutralPrimary: '#253a79',
    neutralDark: '#1c2c5b',
    black: '#7383B2',
    white: '#FFF'
  },
  defaultFontStyle: {
    fontFamily: '"GT Walsheim",sans-serif',
    fontWeight: '400'
  },
  fonts: {
    small: {
      fontSize: '12px'
    },
    medium: {
      fontSize: '18px'
    }
  }
})

const debug = false

export let dependencyRenderer = (dependency: DependencyData, formState: FormState) => (
  <Stack horizontal horizontalAlign={'start'} gap={5}>
    <Text variant={'medium'}>
      <b>Title</b>: {dependency.dependency.title}
    </Text>
    <Text variant={'medium'}>
      <b>Is met?</b> {`${is_dependency_met(dependency.dependency, formState)}`}
    </Text>
    <Text variant={'medium'}>
      <b>Hide if violated?</b> {`${dependency.dependency.hideIfViolated}`}
    </Text>
    <Text variant={'medium'}>
      <b>Kind</b>: {dependency.dependency.Kind}
    </Text>
    <Text variant={'medium'}>
      <b>Dependent fields</b>: {dependency.dependent_fields.map((df) => `${df.FieldId}`).join(',')}
    </Text>
  </Stack>
)

export const stackStyles: IStackStyles = { root: { width: `100%` } }
export const stackStyles1: IStackStyles = { root: { width: `100%` } }

export let fieldRenderer = (
  field: FieldData,
  formState: FormState,
  updateField: (updatedField: FieldData, updatedDependencyState: DependenciesState) => void
) => {
  let isRequired = false
  if (formState.form_data.kind == 'loaded') {
    formState.form_data.value.steps.forEach((s) =>
      s.dependencies.forEach((d) =>
        d.dependent_fields.forEach((f) => {
          if (f.FieldId == field.Id) {
            isRequired = true
          }
        })
      )
    )
  }
  let areDependenciesMetRes = areDependenciesMet(field, formState)
  let defaultSelectedAnswer = field.maybe_answers.find((a) => a.isDefaultSelected)
  const optionalClassName = (input: boolean) => (input ? '' : ' form__label--optional')
  const fieldWidthClassName = (width: 'Extra small' | 'Small' | 'Medium' | 'Large') =>
    width == 'Extra small' ? 'xs' : width == 'Small' ? 's' : width == 'Medium' ? 'm' : 'l'
  const fieldHasErrors = (field: FieldData) => field.user_input != undefined && areDependenciesMetRes.kind == 'no'
  const getFormControlName = (name: string) => `form-name-${field.Id}-${field.Kind}-${slugify(name)}`
  const getFormControlId = (id: string) => `form-${field.Id}-${field.Kind}-${slugify(id)}`
  const getFormControlErrorId = (id: string) => `a11y-error-${getFormControlId(id)}`
  const getFormControlMessageId = (id: string) => `a11y-message-${getFormControlId(id)}`
  const ErrorMessageLayout = ({ copy }: { copy: React.ReactNode }) => (
    <p className='form__error' role='alert' id={getFormControlErrorId(field.title)}>
      {copy}
    </p>
  )
  const DescriptionMessageLayout = ({ copy }: { copy: React.ReactNode }) => (
    <p className='form__description typo--s' id={getFormControlErrorId(field.title)}>
      {copy}
    </p>
  )
  switch (field.Kind) {
    case 'RadioOption':
      return (
        <fieldset
          className={`form__group form__group--radio form__group--${fieldWidthClassName(field.width_percentage)}`}
        >
          <legend className={`form__label form__label--spacing${optionalClassName(isRequired)}`}>
            {field.title}
            {isRequired ? ' *' : ''}
          </legend>
          <ul className='form__radio-button'>
            {field.maybe_answers.map((option) => (
              <li key={getFormControlId(option.value)} className='form__radio-item'>
                <input
                  type='radio'
                  className={`form__button${fieldHasErrors(field) ? ' error' : ''}`}
                  name={getFormControlName(field.title)}
                  id={getFormControlId(option.value)}
                  defaultChecked={option.isDefaultSelected}
                  value={option.value}
                  aria-required={isRequired}
                  aria-invalid={!!fieldHasErrors(field)}
                  aria-describedby={!!fieldHasErrors(field) ? getFormControlErrorId(field.title) : ''}
                  onChange={(e) => {
                    if (field.Kind != 'RadioOption') return
                    let res = update_field_AUX(field, e.currentTarget.value, formState)
                    updateField(res.fieldData, res.dependencyState)
                  }}
                />
                <label htmlFor={getFormControlId(option.value)} className='form__label text--styled'>
                  {option.value}
                </label>
              </li>
            ))}
            {field.user_input != undefined && areDependenciesMetRes.kind == 'no' && (
              <ErrorMessageLayout copy={areDependenciesMetRes.messages.join('. ')} />
            )}
          </ul>
        </fieldset>
      )

    case 'Dropdown':
      const dropdownOptions = !field.useExternalSource
        ? sortBy(
          (a) => a.text,
          field.maybe_answers.map((a) => ({
            key: `select-internal-${a.value}-${a.Id}`,
            text: a.label || a.value,
            value: a.value
          }))
        )
        : !formState.context.external_options.has(field.sourceName)
          ? []
          : sortBy(
            (a) => a.text,
            formState.context.external_options.get(field.sourceName).map((a) => ({
              key: `select-external-${a}`,
              text: a,
              value: a
            }))
          )
      return (
        <div
          className={`form__group form__group--dropdown form__group--${fieldWidthClassName(field.width_percentage)}`}
        >
          <label htmlFor={getFormControlId(field.title)} className={`form__label form__label--spacing${optionalClassName(isRequired)}`}>
            {field.title} {isRequired ? ' *' : ''}
          </label>

          <div className='form__select'>
            <select
              id={getFormControlId(field.title)}
              aria-invalid={!!fieldHasErrors(field)}
              aria-describedby={!!fieldHasErrors(field) ? getFormControlErrorId(field.title) : ''}
              aria-required={isRequired}
              className={`${fieldHasErrors(field) ? ' error' : ''}`}
              value={defaultSelectedAnswer ? defaultSelectedAnswer.value : field.user_input || ''}
              onChange={(e) => {
                if (field.Kind != 'Dropdown') return
                let res = update_field_AUX(field, decodeHTMLEntities(e.currentTarget.value), formState)
                updateField(res.fieldData, res.dependencyState)
              }}
              onBlur={(_) => {
                if (field.user_input == undefined) {
                  let res = update_field_AUX(field, '', formState)
                  updateField(res.fieldData, res.dependencyState)
                }
              }}
            >
              <option value='' disabled>
                {i18next.t('form.make_a_choice')}
              </option>
              {dropdownOptions.map((option) => (
                <option key={option.key} value={option.value}>
                  {decodeHTMLEntities(option.text)}
                </option>
              ))}
            </select>
          </div>
          {field.user_input != undefined && areDependenciesMetRes.kind == 'no' && (
            <ErrorMessageLayout copy={areDependenciesMetRes.messages.join('. ')} />
          )}
        </div>
      )

    case 'Checkbox':
      return (
        <div className={`form__group form__group--${fieldWidthClassName(field.width_percentage)}`}>
          {field.title}

          <div className='form__group--bool form__group--checkbox'>
            <input
              className={`form__bool form__checkbox ${fieldHasErrors(field) ? ' error' : ''}`}
              type='checkbox'
              name={getFormControlName(field.title)}
              id={getFormControlId(field.title)}
              aria-invalid={!!fieldHasErrors(field)}
              aria-describedby={!!fieldHasErrors(field) ? getFormControlErrorId(field.title) : ''}
              aria-required={isRequired}
              defaultChecked={field.optionalDefaultValue.toLowerCase() == 'true'}
              onChange={(e) => {
                let res = update_field_AUX(field, `${e.currentTarget.checked ? true : ''}`.toLowerCase(), formState)
                updateField(res.fieldData, res.dependencyState)
              }}
              onBlur={(_) => {
                if (field.user_input == undefined) {
                  let res = update_field_AUX(field, '', formState)
                  updateField(res.fieldData, res.dependencyState)
                }
              }}
            />
            <label
              className='form__label text--styled'
              htmlFor={getFormControlId(field.title)}
              dangerouslySetInnerHTML={{
                __html: `${field.title + (isRequired ? ' *' : '')}`
              }}
            />
            {field.user_input != undefined && areDependenciesMetRes.kind == 'no' && (
              <ErrorMessageLayout copy={areDependenciesMetRes.messages.join('. ')} />
            )}
          </div>
        </div>
      )

    case 'CheckboxMultiSelect':
      return (
        <fieldset
          className={`form__group form__group--checkbox form__group--${fieldWidthClassName(
            field.width_percentage
          )}`}
        >
          <legend className='form__label'>
            {field.title} {isRequired ? ' *' : ''}
          </legend>
          <div className='checkboxes__wrap'>
            {field.maybe_answers.map((a) => {
              var test = field.user_input.match(/\[(.*?)\]/g)
              var checked = test?.includes(`[${decodeHTMLEntities(a.value)}]`) || false
              if (field.GFFieldType == "consent" && field.user_input == "1") {
                checked = true
              }
              return (
                <div className='checkboxes__item' key={getFormControlId(a.value)}>
                  <input
                    type='checkbox'
                    className={`form__checkbox ${fieldHasErrors(field) ? ' error' : ''}`}
                    name={getFormControlName(decodeHTMLEntities(field.title))}
                    id={getFormControlId(a.value)}
                    aria-invalid={!!fieldHasErrors(field)}
                    aria-describedby={!!fieldHasErrors(field) ? getFormControlErrorId(field.title) : ''}
                    aria-required={isRequired}
                    defaultChecked={a.isDefaultSelected}
                    checked={checked}
                    onChange={(e) => {
                      if (field.Kind != 'CheckboxMultiSelect') return
                      let res = null
                      if (field.GFFieldType == "consent") {
                        if (e.currentTarget.checked) {
                          res = update_field_AUX(field, "1", formState)
                        } else {
                          res = update_field_AUX(field, "0", formState)
                        }
                      } else {
                        if (e.currentTarget.checked) {
                          res = update_field_AUX(field, field.user_input + '[' + decodeHTMLEntities(a.value) + ']', formState)
                        } else {
                          res = update_field_AUX(field, field.user_input.replace('[' + decodeHTMLEntities(a.value) + ']', ''), formState)
                        }
                      }

                      updateField(res.fieldData, res.dependencyState)
                    }}
                  />
                  <label
                    className='form__label form__label--checkbox'
                    htmlFor={getFormControlId(a.value)}
                    dangerouslySetInnerHTML={{
                      __html: a.value
                    }}
                  ></label>
                </div>
              )
            })}
          </div>
          {field.user_input != undefined && areDependenciesMetRes.kind == 'no' && (
            <ErrorMessageLayout copy={areDependenciesMetRes.messages.join('. ')} />
          )}
        </fieldset>
      )

    case 'SimpleDate':
      return (
        <div
          onBlur={(_) => {
            if (field.user_input == undefined) {
              let res = update_field_AUX(field, '', formState)
              updateField(res.fieldData, res.dependencyState)
            }
          }}
          className={`form__group form__group--datepicker form__group--${fieldWidthClassName(field.width_percentage)}`}
        >
          <label className={`form__label${optionalClassName(isRequired)}`}>
            {field.title} {isRequired ? ' *' : ''}
          </label>
          {(() => {
            const onFormatDate = (date?: Date): string => {
              return !date ? '' : moment(date).format('DD-MM-YYYY')
            }

            const onParseDateFromString = (newValue: string): Date => {
              return moment(newValue, 'DD-MM-YYYY')?.toDate() || moment(field.user_input, 'DD-MM-YYYY')?.toDate() || new Date()
            }
            return (
              <DatePicker
                firstDayOfWeek={1}
                strings={DayPickerStrings}
                allowTextInput
                placeholder={field.placeholder != undefined ? field.placeholder : ''}
                ariaLabel='Select a date'
                value={
                  field.user_input === '' || field.user_input === undefined
                    ? undefined
                    : moment(field.user_input).toDate()
                }
                formatDate={onFormatDate}
                parseDateFromString={onParseDateFromString}
                minDate={
                  (field.StartDate as any) == ''
                    ? null
                    : typeof field.StartDate == 'string'
                      ? moment(field.StartDate).toDate()
                      : field.StartDate.toDate()
                }
                onSelectDate={(new_date) => {
                  if (new_date == null || new_date == undefined) return
                  let res = update_field_AUX(field, moment(new_date, 'DD-MM-YYYY').format(), formState)
                  updateField(res.fieldData, res.dependencyState)
                }}
              />
            )
          })()}

          {field.user_input != undefined && areDependenciesMetRes.kind == 'no' && (
            <ErrorMessageLayout copy={areDependenciesMetRes.messages.join('. ')} />
          )}
        </div>
      )
    case 'Attachement':
      const allowedExtensions = '.pdf'
      return (
        <div
          className={`form__group form__group--attachment form__group--${fieldWidthClassName(field.width_percentage)}`}
        >
          <label className={`form__label${optionalClassName(isRequired)}`} htmlFor={getFormControlId(field.title)}>
            {field.title}
            {isRequired ? ' *' : ''}
          </label>

          <input
            type='file'
            id={getFormControlId(field.title)}
            placeholder={field.placeholder != undefined ? field.placeholder : ''}
            className={`form__input ${fieldHasErrors(field) ? ' error' : ''}`}
            accept={allowedExtensions}
            aria-invalid={!!fieldHasErrors(field)}
            aria-describedby={!!fieldHasErrors(field) ? getFormControlId(field.title) : ''}
            aria-required={isRequired}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              let files: FileList = (e.target as any).files
              let file = files[0]
              let extension = '.' + (file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length) || file.name)
              if (!allowedExtensions.includes(extension)) {
                window.alert(i18next.t('Form:form_only_pdf'))
                e.preventDefault()
                let res = update_field_file(field, null, '', formState)
                updateField(res.fieldData, res.dependencyState)
                return
              }
              let res = update_field_file(field, files[0], files[0].name, formState)
              updateField(res.fieldData, res.dependencyState)
            }}
            onBlur={(_) => {
              if (field.user_input == undefined) {
                let res = update_field_AUX(field, '', formState)
                updateField(res.fieldData, res.dependencyState)
              }
            }}
          />

          {field.user_input != undefined && areDependenciesMetRes.kind == 'no' && (
            <ErrorMessageLayout
              copy={areDependenciesMetRes.messages
                .join('. ')
                .concat(field.user_input == '' && i18next.t('Form:form_only_pdf'))}
            />
          )}
        </div>
      )
    case 'ReadonlyText':
      return (
        <div
          className={`form__group form__group--readonly form__group--${fieldWidthClassName(
            field.width_percentage
          )} text--styled`}
        >
          <div dangerouslySetInnerHTML={{ __html: parseParagraphs(field.Description) }} />
        </div>
      )
    case 'TextArea':
      return (
        <div
          className={`form__group form__group--textarea form__group--${fieldWidthClassName(field.width_percentage)}`}
        >
          <label className={`form__label form__label--spacing ${optionalClassName(isRequired)}`} htmlFor={getFormControlId(field.title)}>
            {field.title} {isRequired ? ' *' : ''}
          </label>
          <textarea
            id={getFormControlId(field.title)}
            aria-invalid={!!fieldHasErrors(field)}
            aria-describedby={
              !!fieldHasErrors(field)
                ? getFormControlErrorId(field.title)
                : '' + ' ' + getFormControlMessageId(field.title)
            }
            aria-required={isRequired}
            className={`form__input form__textarea ${fieldHasErrors(field) ? ' error' : ''}`}
            placeholder={field.placeholder != undefined ? field.placeholder : ''}
            value={field.user_input ? field.user_input : ''}
            rows={4}
            maxLength={4500}
            onChange={(e) => {
              let res = update_field_AUX(field, e.currentTarget.value, formState)
              updateField(res.fieldData, res.dependencyState)
            }}
            onBlur={(_) => {
              if (field.user_input == undefined) {
                let res = update_field_AUX(field, '', formState)
                updateField(res.fieldData, res.dependencyState)
              }
            }}
          />
          <DescriptionMessageLayout copy={""} />
          {field.user_input != undefined && areDependenciesMetRes.kind == 'no' && (
            <ErrorMessageLayout copy={areDependenciesMetRes.messages.join('. ')} />
          )}
        </div>
      )
    default:
      return (
        <div
          className={`form__group form__group--input form__group--${fieldWidthClassName(field.width_percentage)}${fieldHasErrors(field) ? ' form__group--error' : ''
            }`}
        >
          <label htmlFor={getFormControlId(field.title)} className={`form__label${optionalClassName(isRequired)}`}>
            {field.title} {isRequired ? ' *' : ''}
          </label>
          <input
            type={field.Kind == 'UserEmail' ? 'email' : field.Kind == 'Phone' ? 'tel' : 'text'}
            id={getFormControlId(field.title)}
            aria-invalid={!!fieldHasErrors(field)}
            aria-describedby={!!fieldHasErrors(field) ? getFormControlErrorId(field.title) : ''}
            aria-required={isRequired}
            placeholder={field.placeholder != undefined ? field.placeholder : ''}
            className={`form__input ${fieldHasErrors(field) ? ' error' : ''}`}
            value={`${field.user_input ? field.user_input : ''}`}
            onChange={(e) => {
              let res = update_field_AUX(field, e.currentTarget.value, formState)
              updateField(res.fieldData, res.dependencyState)
            }}
            onBlur={(_) => {
              if (field.user_input == undefined) {
                let res = update_field_AUX(field, '', formState)
                updateField(res.fieldData, res.dependencyState)
              }
            }}
          />
          {field.user_input != undefined && areDependenciesMetRes.kind == 'no' && (
            <ErrorMessageLayout copy={areDependenciesMetRes.messages.join('. ')} />
          )}
        </div>
      )
  }
}

export let stepRenderer = (
  step: StepData,
  formState: FormState,
  update_step: (updated_step: StepData, updatedDependencyState: DependenciesState) => void
) => (
  <div className='block__step'>
    {step.fields
      .sort((a, b) => (a.itemOrderNumber < b.itemOrderNumber ? -1 : a.itemOrderNumber > b.itemOrderNumber ? 1 : 0))
      .map((field, i) =>
        fieldRenderer(field, formState, (field1, updated_dependencies) =>
          update_step({ ...step, fields: update_elem_in_list(step.fields, i, field1) }, updated_dependencies)
        )
      )}
    {debug ? (
      <div>
        <p> Dependencies: </p>
        <div>{step.dependencies.map((dependency) => dependencyRenderer(dependency, formState))}</div>
      </div>
    ) : null}
  </div>
)

export let formRenderer = (
  data: FormData,
  formState: FormState,
  updateFormSubmissionLogic: (updated_form_submission_logic: AsyncState<string>) => void,
  updateForm: (updated_form: FormData, updatedDependencyState: DependenciesState) => void
) => {
  const areDependenciesMet = are_all_dependencies_met(formState)

  if (formState.form_submission_logic.kind == 'loaded' &&
    formState.form_submission_logic.value == 'ok' &&
    formState.form_data.kind == 'loaded' &&
    !StringEmptyOrNull(formState.form_data.value.thank_you.redirectUrl)) {
      window.location.href = formState.form_data.value.thank_you.redirectUrl
      return <p>Redirecting...</p>
  }

  return (
    <form
      className='form'
      onSubmit={(e) => {
        gtmPush({
          event: "form_submit",
        })
        e.preventDefault()
        if (window.location.href.includes('opdrachten/id')) {
          // datalayerHandler('vacancies', 'submit_application', 'vacancies')
        } else if (window.location.href.includes('contact')) {
          // datalayerHandler('contact', 'submit', 'contact')
        } else {
          // window._mtm.push({
          //   event: `event.${window.site.Name}`,
          //   category: data.form.title,
          //   action: 'submit_form',
          //   label: window.location.pathname
          // })
        }
        if (formState.alternative_submit_api) {
          updateFormSubmissionLogic(formState.alternative_submit_api(data.form.Id, formState))
        } else {
          updateFormSubmissionLogic(postFormSubmissionState(data.form.Id, formState))
        }
      }}
    >
      {formState.form_submission_logic.kind == 'loading' && status_sending_renderer()}

      {formState.form_submission_logic.kind == 'loaded' &&
        formState.form_submission_logic.value == 'ok' &&
        formState.form_data.kind == 'loaded' &&
        StringEmptyOrNull(formState.form_data.value.thank_you.redirectUrl) &&
        status_thank_you_renderer(formState.form_data.value.thank_you.content)}

      {formState.form_submission_logic.kind == 'connection-error' &&
        formState.form_submission_logic.retryCount >= 10 &&
        status_error_renderer()}

      {formState.form_submission_logic.kind == 'loaded' &&
        formState.form_submission_logic.value == 'ok' &&
        formState.form_data.kind == 'loaded' ? null : (
        <div className='form__inner'>
          <div className='form__content'>
            {data.steps
              .sort((a, b) =>
                a.step.orderNumber < b.step.orderNumber ? -1 : a.step.orderNumber > b.step.orderNumber ? 1 : 0
              )
              .map((step, i) =>
                stepRenderer(step, formState, (step1, updated_dependencies) =>
                  updateForm({ ...data, steps: update_elem_in_list(data.steps, i, step1) }, updated_dependencies)
                )
              )}
          </div>
          {/*Sometimes the form is so big that you don't see the message ate the top. So also place this at the bottom of the form */}
          {formState.form_submission_logic.kind == 'loading' && status_sending_renderer()}

          <footer className='block__footer'>
            <button
              disabled={!areDependenciesMet || formState.form_submission_logic.kind == 'loading'}
              type='submit'
              className='button button--primary form__submit'
            // we disable the form when the submission is being send
            >
              <span>{i18next.t('form.form_submit')}</span>
            </button>
          </footer>
        </div>
      )}
    </form>
  )
}
